/* BG COM — shared hotspot runtime.
   Any element with data-bgh-handle (a product) or data-bgh-text (an info point) becomes a
   hotspot trigger. The product card is rendered by Shopify through the Section Rendering API
   (sections/bgcom-hotspot-card.liquid), so price, stock and SKU are always live.

   Per-trigger options (all optional):
     data-bgh-label   tag shown on the card ("Pièce détachée", "Vendu séparément", "Recharge"…)
     data-bgh-compat  compatibility line ("Compatible NOVA 3")
     data-bgh-title   short title (e.g. "Joint intérieur" instead of the full product title)
     data-bgh-text / data-bgh-link / data-bgh-link-label   for info points without a product

   API: window.BGH.bind(root)  — bind triggers inside root (idempotent)
        window.BGH.close()     — close the open card
   Fires "bgh:ready" on document when loaded, "bgh:added" after an add to cart. */
(function () {
  if (window.BGH) return;

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var cache = {};                 // handle -> Promise<HTMLElement>
  var pop, line, lineEl, backdrop;
  var openTrigger = null;
  var viaPointer = false;
  document.addEventListener('pointerdown', function () { viaPointer = true; }, true);
  document.addEventListener('keydown', function () { viaPointer = false; }, true);

  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function ensureShell() {
    if (pop) return;
    backdrop = el('div', 'bgh-backdrop');
    backdrop.addEventListener('click', close);
    line = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    line.setAttribute('class', 'bgh-line');
    line.setAttribute('aria-hidden', 'true');
    lineEl = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.appendChild(lineEl);
    line.style.display = 'none';
    pop = el('div', 'bgh-pop');
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'false');
    document.body.appendChild(backdrop);
    document.body.appendChild(line);
    document.body.appendChild(pop);
  }

  /* ---------- data ---------- */
  function fetchCard(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=bgcom-hotspot-card', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          var card = d.querySelector('[data-bgh-card]');
          if (!card) throw new Error('no card');
          return card;
        })
        .catch(function (err) { delete cache[handle]; throw err; });
    }
    return cache[handle];
  }

  function textCard(t) {
    var c = el('div', 'bgh-card bgh-card--text');
    var h = '<div class="bgh-card__main"><div class="bgh-card__body">';
    if (t.getAttribute('data-bgh-label')) h += '<div class="bgh-card__meta"><span class="bgh-tag">' + esc(t.getAttribute('data-bgh-label')) + '</span></div>';
    h += '<p class="bgh-card__t" style="margin-top:7px">' + esc(t.getAttribute('data-bgh-title') || '') + '</p>';
    if (t.getAttribute('data-bgh-text')) h += '<p class="bgh-card__txt">' + esc(t.getAttribute('data-bgh-text')) + '</p>';
    h += '</div></div>';
    var link = t.getAttribute('data-bgh-link');
    if (link) h += '<div class="bgh-card__foot"><a class="bgh-more" href="' + esc(link) + '">' + esc(t.getAttribute('data-bgh-link-label') || 'En savoir plus') + ' <span aria-hidden="true">→</span></a></div>';
    c.innerHTML = h;
    return c;
  }

  function personalise(card, t) {
    var label = t.getAttribute('data-bgh-label');
    var compat = t.getAttribute('data-bgh-compat');
    var title = t.getAttribute('data-bgh-title');
    var sl = card.querySelector('[data-bgh-slot="label"]');
    var sc = card.querySelector('[data-bgh-slot="compat"]');
    var stt = card.querySelector('[data-bgh-slot="title"]');
    if (label && sl) sl.textContent = label;
    if (compat && sc) { sc.textContent = compat; sc.hidden = false; }
    if (title && stt) stt.textContent = title;
    return card;
  }

  /* ---------- open / place / close ---------- */
  function headerBottom() {
    var best = 0;
    document.querySelectorAll('header, sticky-header, .header-wrapper, [id*="header-group"] > *').forEach(function (h) {
      var cs = getComputedStyle(h);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = h.getBoundingClientRect();
      if (r.top <= 2 && r.height > 4 && r.height < 240 && r.bottom > best) best = r.bottom;
    });
    return best;
  }

  function place() {
    if (!openTrigger || !pop.classList.contains('is-open')) return;
    if (MOBILE.matches) { line.style.display = 'none'; return; }
    var r = openTrigger.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var vw = window.innerWidth, vh = window.innerHeight;
    if (cy < 0 || cy > vh || cx < 0 || cx > vw) { close(); return; }
    var w = pop.offsetWidth, h = pop.offsetHeight, gap = 30, pad = 12;
    var minTop = Math.max(pad, headerBottom() + pad);
    var top = cy - r.height / 2 - gap - h;               // above the dot by default
    if (top < minTop) top = cy + r.height / 2 + gap;     // not enough room: below
    if (top + h > vh - pad) top = Math.max(minTop, vh - pad - h);
    var left = Math.min(Math.max(cx - w / 2, pad), vw - w - pad);
    pop.style.left = Math.round(left) + 'px';
    pop.style.top = Math.round(top) + 'px';
    // leader line: dot edge -> nearest point of the card
    var nx = Math.min(Math.max(cx, left + 16), left + w - 16);
    var ny = cy < top ? top : (cy > top + h ? top + h : cy);
    var dx = nx - cx, dy = ny - cy, len = Math.sqrt(dx * dx + dy * dy) || 1;
    var sx = cx + dx / len * 14, sy = cy + dy / len * 14;
    lineEl.setAttribute('x1', sx); lineEl.setAttribute('y1', sy);
    lineEl.setAttribute('x2', nx); lineEl.setAttribute('y2', ny);
    line.style.display = len > 18 ? 'block' : 'none';
  }

  function open(t) {
    ensureShell();
    if (openTrigger === t) { close(); return; }
    close(true);
    openTrigger = t;
    t.classList.add('is-on');
    t.setAttribute('aria-expanded', 'true');
    var handle = t.getAttribute('data-bgh-handle');
    var titleForA11y = t.getAttribute('data-bgh-title') || t.getAttribute('aria-label') || 'Produit';
    pop.setAttribute('aria-label', titleForA11y);
    pop.innerHTML = '';
    var holder = el('div', 'bgh-card is-loading');
    pop.appendChild(holder);
    show();
    var p = handle ? fetchCard(handle).then(function (c) { return personalise(c.cloneNode(true), t); }) : Promise.resolve(textCard(t));
    p.then(function (card) {
      if (openTrigger !== t) return;
      var x = el('button', 'bgh-x'); x.type = 'button'; x.setAttribute('aria-label', 'Fermer'); x.innerHTML = '&times;';
      x.addEventListener('click', function () { close(); });
      card.insertBefore(x, card.firstChild);
      pop.innerHTML = ''; pop.appendChild(card);
      wire(card);
      paintPro(card);
      requestAnimationFrame(place);
      // move focus into the card for keyboard users only (a mouse/touch open shouldn't flash a focus ring)
      if (!viaPointer) {
        var focusTarget = card.querySelector('[data-bgh-add]') || card.querySelector('.bgh-card__t, .bgh-more');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
    }).catch(function () {
      if (openTrigger !== t) return;
      var url = handle ? '/products/' + handle : null;
      holder.classList.remove('is-loading');
      holder.innerHTML = '<p class="bgh-card__txt">Impossible de charger ce produit.' + (url ? ' <a href="' + esc(url) + '">Ouvrir la fiche</a>' : '') + '</p>';
    });
  }

  function show() {
    backdrop.style.display = '';
    var t = openTrigger, done = false;
    // rAF gives the enter transition; the timeout guarantees the card opens even when frames are throttled
    var add = function () {
      if (done || openTrigger !== t) return;
      done = true;
      pop.classList.add('is-open');
      backdrop.classList.add('is-open');
      place();
    };
    requestAnimationFrame(add);
    setTimeout(add, 80);
  }

  function close(silent) {
    if (!pop) return;
    var t = openTrigger;
    openTrigger = null;
    pop.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    line.style.display = 'none';
    if (t) {
      t.classList.remove('is-on');
      t.setAttribute('aria-expanded', 'false');
      if (!silent && pop.contains(document.activeElement)) t.focus({ preventScroll: true });
    }
  }

  /* ---------- pro price (same source as the buy box and catalogue cards) ---------- */
  var proReq = {};
  function paintPro(card) {
    var wrap = card.querySelector('.bgcom-card-wrap[data-product-id]');
    if (!wrap) return;
    var target = wrap.querySelector('.bgcom-samita-target');
    if (!target || target.getAttribute('data-customer') !== '1') return; // guests keep the public price
    var pid = wrap.getAttribute('data-product-id');
    var render = function () { if (window.bgcomRenderPrices) window.bgcomRenderPrices(card); };
    if (window.bgcomWholesaleData && window.bgcomWholesaleData[pid]) { render(); return; }
    if (!proReq[pid]) {
      proReq[pid] = fetch('/apps/wholesale/cardprices', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids: [pid] })
      }).then(function (r) { return r.json(); }).then(function (map) {
        if (map && map[pid] && map[pid].w) {
          window.bgcomWholesaleData = window.bgcomWholesaleData || {};
          window.bgcomWholesaleData[pid] = map[pid].w;
          if (window.bgcomPersistWS) window.bgcomPersistWS();
        }
      }).catch(function () { delete proReq[pid]; });
    }
    proReq[pid].then(render);
  }

  /* ---------- quantity + add to cart ---------- */
  function wire(card) {
    var input = card.querySelector('[data-bgh-qty-input]');
    card.querySelectorAll('[data-bgh-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-bgh-qty'), 10);
        input.value = Math.max(1, Math.min(999, v));
      });
    });
    if (input) input.addEventListener('change', function () { input.value = Math.max(1, Math.min(999, parseInt(input.value, 10) || 1)); });
    var add = card.querySelector('[data-bgh-add]');
    if (!add) return;
    var msg = card.querySelector('.bgh-msg');
    var label = add.querySelector('span');
    add.addEventListener('click', function () {
      if (add.disabled) return;
      var qty = Math.max(1, parseInt(input && input.value, 10) || 1);
      add.disabled = true; label.textContent = 'Ajout…'; if (msg) msg.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +card.getAttribute('data-variant'), quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
          add.classList.add('is-ok'); label.textContent = qty > 1 ? 'Ajoutés ✓' : 'Ajouté ✓';
          var cartLink = card.querySelector('.bgh-cart'); if (cartLink) cartLink.hidden = false;
          document.dispatchEvent(new CustomEvent('bgh:added', { detail: { variant: +card.getAttribute('data-variant'), quantity: qty, cart: cart } }));
          setTimeout(function () { add.classList.remove('is-ok'); label.textContent = 'Ajouter'; add.disabled = false; }, 2200);
        })
        .catch(function (err) {
          label.textContent = 'Ajouter'; add.disabled = false;
          if (msg) msg.textContent = (err && (err.description || err.message)) ? (err.description || err.message) : "L'ajout n'a pas abouti. Réessayez ou ouvrez la fiche produit.";
        });
    });
  }

  /* ---------- binding ---------- */
  function bind(root) {
    (root || document).querySelectorAll('[data-bgh-handle], [data-bgh-text]').forEach(function (t) {
      if (t.dataset.bghBound) return;
      t.dataset.bghBound = '1';
      if (t.tagName !== 'BUTTON' && t.tagName !== 'A') { t.setAttribute('role', 'button'); t.tabIndex = 0; }
      t.setAttribute('aria-haspopup', 'dialog');
      t.setAttribute('aria-expanded', 'false');
      var handle = t.getAttribute('data-bgh-handle');
      if (handle) {
        var warm = function () { fetchCard(handle).catch(function () {}); };
        t.addEventListener('pointerenter', warm, { once: true });
        t.addEventListener('focus', warm, { once: true });
      }
      t.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(t); });
      t.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && t.tagName !== 'BUTTON') { e.preventDefault(); open(t); } });
    });
  }

  document.addEventListener('click', function (e) {
    if (!openTrigger || !pop) return;
    if (pop.contains(e.target) || openTrigger.contains(e.target)) return;
    close(true);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openTrigger) close(); });
  var ticking = false;
  function onMove() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; place(); }); }
  window.addEventListener('scroll', onMove, { passive: true });
  window.addEventListener('resize', onMove, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });

  window.BGH = { bind: bind, close: function () { close(true); }, open: open };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.dispatchEvent(new CustomEvent('bgh:ready'));
})();
